<div class="chart-container">
    <div class="flex mb-2 position-relative">
        <app-report-filters
            [icao]="icao"
            [dataSource]="dataSource"
            [selectedDateFilter]="selectedDateFilter"
            (onChangeIcaoFilter)="changeIcaoFilter($event)"
            (onDateChange)="applyPresetDateFilter($event)"
            (commercialAicraftToogle)="filterChanged($event)"
        >
        </app-report-filters>
        <div class="actions">
            <button [matMenuTriggerFor]="gridActions" mat-icon-button>
                <mat-icon
                    aria-hidden="true"
                    class="mat-icon material-icons"
                    role="img"
                    >settings</mat-icon
                >
            </button>
            <mat-menu
                #gridActions="matMenu"
                class="switch-nested-menu-left-arrows"
                xPosition="before"
            >
                <button (click)="openSettings()" mat-menu-item>Settings</button>
            </mat-menu>
        </div>
    </div>

    <div *ngIf="isProgressiveLoading" class="progressive-loading-note">
        <div class="progressive-loading-bar">
            <div class="progressive-loading-bar-fill" [style.width.%]="loadProgressPercent"></div>
        </div>
        <span>Loading {{ loadedCount | number }} of {{ progressTotalCount | number }} flights&hellip;</span>
    </div>
    <div *ngIf="isProgressiveLoading && hasActiveGridFilter" class="progressive-loading-search-note">
        Search results may be incomplete &mdash; flights are still loading ({{ loadedCount | number }} of {{ progressTotalCount | number }} so far).
    </div>
    <div *ngIf="!isProgressiveLoading && hasLoadGaps" class="progressive-loading-warning">
        Only {{ loadedCount | number }} of {{ progressTotalCount | number }} flights loaded &mdash; some data could not be retrieved. Refresh to retry.
    </div>

    <div
        class="table-container mat-elevation-z3"
        (scroll)="onTableScroll($event)"
    >
        <table [dataSource]="dataSource"
               [trackBy]="trackByRow"
               mat-table
               matSort
               matSortActive="dateTime"
               matSortDirection="desc">
            <ng-container matColumnDef="company">
                <th *matHeaderCellDef mat-header-cell>
                    <span *ngIf="dataSource">
                        <app-table-column-filter [matDataSource]="dataSource"
                                                 [matSort]="sort"
                                                 columnId="company"
                                                 propertyName="company">
                            <span>Company</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    <a *ngIf="info.customerInfoByGroupID > 0" (click)="goToCustomerDetails(info); $event.stopPropagation()" class="btn-link">{{ info.company | uppercase }}</a>
                    <span *ngIf="!info.customerInfoByGroupID || info.customerInfoByGroupID <= 0">{{ info.company }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="tailNumber">
                <th *matHeaderCellDef mat-header-cell>
                    <span *ngIf="dataSource">
                        <app-table-column-filter [matDataSource]="dataSource"
                                                 [matSort]="sort"
                                                 columnId="tailNumber"
                                                 propertyName="tailNumber">
                            <span>Tail #</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    <span *ngIf="isJetNetIntegrationEnabled && info.tailNumber && info.tailNumber.trim().length >= 2 && (info.companyId == null || info.companyId == 0)"><a (click)="tailNumberSearch(info.tailNumber)" class="btn-link">{{ info.tailNumber }}</a></span>
                    <span *ngIf="!isJetNetIntegrationEnabled || !info.tailNumber || info.tailNumber.trim().length < 2 || info.companyId > 0"> {{ info.tailNumber }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="customerActionStatus">
                <th *matHeaderCellDef mat-header-cell>
                    <span *ngIf="dataSource">
                        <app-table-column-filter [matDataSource]="dataSource"
                                                 [matSort]="sort"
                                                 columnId="customerNeedsAttention"
                                                 propertyName="customerNeedsAttention"
                                                 [columnFormat]="10"
                                                 optionLabel="label"
                                                 optionValue="value"
                                                 [options]="needsAttentionOptions"
                                                 >
                            <span>Customer Action Status</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    <div style="max-width:150px;">
                        <app-customer-action-status matTooltipPosition="after" customerActionStatusEmailRequired="{{info.customerActionStatusEmailRequired}}" customerActionStatusNewCustomer="{{info.customerActionStatusNewCustomer}}"  customerActionStatusSetupRequired="{{info.customerActionStatusSetupRequired}}" customerActionStatusTopCustomer="{{info.customerActionStatusTopCustomer}}" moreThan2Badges="{{info.moreThan2Badges}}" toolTipEmailRequired="{{info.toolTipEmailRequired}}" toolTipSetupRequired="{{info.toolTipSetupRequired}}" toolTipTopCustomer="{{info.toolTipTopCustomer}}" toolTipNewCustomer="{{info.toolTipNewCustomer}}"></app-customer-action-status>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="flightNumber">
                <th *matHeaderCellDef mat-header-cell>
                    <span *ngIf="dataSource">
                        <app-table-column-filter [matDataSource]="dataSource"
                                                 [matSort]="sort"
                                                 columnId="flightNumber"
                                                 propertyName="flightNumber">
                            <span>Flight #</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    {{ info.flightNumber }}
                </td>
            </ng-container>

            <ng-container matColumnDef="originated">
                <th *matHeaderCellDef mat-header-cell>
                    <span *ngIf="dataSource">
                        <app-table-column-filter [matDataSource]="dataSource"
                                                 [matSort]="sort"
                                                 columnId="originated"
                                                 propertyName="originated">
                            <span>Origin ICAO</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    {{ info.originated }}
                </td>
            </ng-container>

            <ng-container matColumnDef="hexCode">
                <th *matHeaderCellDef mat-header-cell>
                    <span *ngIf="dataSource">
                        <app-table-column-filter [matDataSource]="dataSource"
                                                 [matSort]="sort"
                                                 columnId="hexCode"
                                                 propertyName="hexCode">
                            <span>Hex #</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    {{ info.hexCode }}
                </td>
            </ng-container>

            <ng-container matColumnDef="aircraftType">
                <th *matHeaderCellDef mat-header-cell>
                    <span *ngIf="dataSource">
                        <app-table-column-filter [matDataSource]="dataSource"
                                                 [matSort]="sort"
                                                 columnId="aircraftType"
                                                 propertyName="aircraftType">
                            <span>Aircraft</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    {{ info.aircraftType }}
                </td>
            </ng-container>

            <ng-container matColumnDef="dateTime">
                <th *matHeaderCellDef mat-header-cell>
                    <span *ngIf="dataSource">
                        <app-table-column-filter [matDataSource]="dataSource"
                                                 [matSort]="sort"
                                                 columnId="dateTime"
                                                 propertyName="dateTime"
                                                 [columnFormat]="4">
                            <span>Date and Time</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    {{
                        info.flightNumber || !info.percentOfVisits
                            ? (getlocalDateTime(info.dateTime) | date : "MM/dd/YYYY HH:mm")
                            : ""
                    }}
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th *matHeaderCellDef mat-header-cell>
                    <span *ngIf="dataSource">
                        <app-table-column-filter [matDataSource]="dataSource"
                                                 [matSort]="sort"
                                                 columnId="status"
                                                 propertyName="status"
                                                 [columnFormat]="10"
                                                 optionLabel="label"
                                                 optionValue="value"
                                                 [options]="statusOptions">
                            <span>Departure / Arrival</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    {{ info.status }}
                </td>
            </ng-container>

            <ng-container matColumnDef="pastVisits">
                <th *matHeaderCellDef mat-header-cell>
                    <span *ngIf="dataSource">
                        <app-table-column-filter [matDataSource]="dataSource"
                                                 [matSort]="sort"
                                                 columnId="pastVisits"
                                                 propertyName="pastVisits"
                                                 [columnFormat]="1">
                            <span>Past Visits</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    {{ info.pastVisits }}
                </td>
            </ng-container>

            <ng-container matColumnDef="visitsToMyFbo">
                <th *matHeaderCellDef mat-header-cell>
                    <span *ngIf="dataSource">
                        <app-table-column-filter [matDataSource]="dataSource"
                                                 [matSort]="sort"
                                                 columnId="visitsToMyFbo"
                                                 propertyName="visitsToMyFbo"
                                                 [columnFormat]="1">
                            <span>Visits to {{ fboName }}</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    {{ info.visitsToMyFbo }}
                </td>
            </ng-container>

            <ng-container matColumnDef="isConfirmedVisit">
                <th *matHeaderCellDef mat-header-cell>
                    <span *ngIf="dataSource">
                        <app-table-column-filter [matDataSource]="dataSource"
                                                 [matSort]="sort"
                                                 columnId="isConfirmedVisit"
                                                 propertyName="isConfirmedVisit"
                                                 [columnFormat]="8">
                            <span>Visit to {{ fboName }}?</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell clickStopPropagation>
                    <mat-slide-toggle *ngIf="info.status == 'Arrival'"
                                      color="primary"
                                      [(ngModel)]="info.isParkedWithinGeofence"
                                      (change)="confirmedVisitToggled(info)">
                    </mat-slide-toggle>
                </td>
            </ng-container>

            <ng-container matColumnDef="percentOfVisits">
                <th *matHeaderCellDef mat-header-cell>
                    <span *ngIf="dataSource">
                        <app-table-column-filter [matDataSource]="dataSource"
                                                 [matSort]="sort"
                                                 columnId="percentOfVisits"
                                                 propertyName="percentOfVisits"
                                                 [columnFormat]="1">
                            <span>Percent of Visits</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    {{ info.percentOfVisits | percent }}
                </td>
            </ng-container>

            <tr *matHeaderRowDef="visibleColumns; sticky: true"
                mat-header-row></tr>
            <tr *matRowDef="let row; columns: visibleColumns"
                mat-row class="example-element-row"
                (click)="onClickAircraft(row)"></tr>
        </table>

        <ngx-ui-loader
            [loaderId]="chartName"
            bgsColor="rgb(100, 181, 246)"
            bgsPosition="center-center"
            bgsType="ball-spin"
            overlayColor="rgba(0, 0, 0, 0.1)"
        ></ngx-ui-loader>
        <div class="invisible">
            <mat-paginator
                [pageSizeOptions]="[10, 25, 50, 100]"
                showFirstLastButtons
            ></mat-paginator>
        </div>
    </div>
</div>
